export { CustomerPopupsPage } from './view/customer-popups-page';

export { default as customerPopupReducer } from './slice';
export { customerPopupsSagas } from './saga';
